import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { selectStartDate } from './selectors';

const selectLoadAppliedFertilizerEntitiesParams = createDeepEqualSelector(
    selectStartDate,
    selectCurrentOrganizationId,
    (date, organizationId) => ({
        organizationId,
        filter: {
            fields: ['id'],
            require: {
                'fertilizerEvents.event.startDate': date,
                'fertilizerEvents.event.deletedAt': { $exists: false }
            }
        }
    })
);

export { selectLoadAppliedFertilizerEntitiesParams };
